import React from 'react';
import cx from 'classnames';

import { GreenButton } from '@marketing/components/buttons';
import InteractivePrompt from '@marketing/components/interactive_prompt';
import { OfferProps } from '@marketing/types';
import { formatOfferPrice } from '@marketing/utilities/offer_price';

import styles from './style.module.scss';

interface Props {
  header: string | React.ReactNode;
  interactivePrompt: {
    answerChoices: string[] | React.ReactNode;
    prompt: string | React.ReactNode;
    subject: string;
  }
  startingOffer: OfferProps;
  subCTA?: string | React.ReactNode;
  subHeader: string | React.ReactNode;
}

export default (props: Props) => {
  return (
    <div className="d-flex" style={{ gap: 30 }}>
      <div className="d-flex flex-column gap-m" style={{ minWidth: '52%' }}>
        <h1 className={cx('u-margin-A-n text-bold text-gray-darker', styles.heroHeader)}>
          {props.header}
        </h1>

        <div className="text-inter" style={{ fontSize: 18 }}>
          {props.subHeader}
        </div>

        <div className="d-flex flex-column gap-m u-margin-T-s">
          <div>
            <GreenButton className="flex-1 flex-lg-none" href="/plans#offers">
              Full course starts at {formatOfferPrice(props.startingOffer)}
            </GreenButton>
          </div>

          {
            props.subCTA && (
              <div>
                {props.subCTA}
              </div>
            )
          }
        </div>
      </div>

      <div className="hidden-xs hidden-sm" style={{ minWidth: 800, width: 800 }}>
        <div
          className="d-flex flex-column gap-m"
          style={{
            // TODO - linear gradient border that fades to transparent on the right
            border: '1px solid rgba(92, 92, 92, 0.15)',
            borderRadius: 28,
            padding: 15
          }}
        >
          <div className="d-flex" style={{ gap: 8, marginLeft: 5 }}>
            <div style={{ backgroundColor: '#FF5F57', border: '1px solid #CB2B23', borderRadius: 10, height: 10, width: 10 }} />
            <div style={{ backgroundColor: '#FFBC2E', border: '1px solid #E5A214', borderRadius: 10, height: 10, width: 10 }} />
            <div style={{ backgroundColor: '#29C940', border: '1px solid #0FAF26', borderRadius: 10, height: 10, width: 10 }} />
          </div>

          <div
            style={{
              backgroundImage: 'linear-gradient(to right, #fff, #fff 450px, rgba(255, 255, 255, 0.15) 90%, transparent 100%)',
              border: '1px solid rgba(92, 92, 92, 0.2)',
              borderRadius: 12,
              boxShadow: '0 26px 24px rgba(0, 0, 0, 0.03), 0 7px 9px rgba(0, 0, 0, 0.03)',
              padding: 20
            }}
          >
            <InteractivePrompt {...props.interactivePrompt} />
          </div>
        </div>
      </div>
    </div>
  );
};
